"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.prebuiltEmployeeMotivation = void 0;
const templateUtils_1 = require("../../templateUtils");
const triggerFormContent = {
    subject: 'Employee Motivation Survey',
    contentType: 'html',
    contentData: [
        {
            type: 'display-image',
            version: '1',
            id: '1bf05c16-7ec8-47d2-a3d9-e9a4bb55f19e',
            data: {
                src: 'https://d1ccvuha0qk3lj.cloudfront.net/uploads/general/Employee-Motivation-Survey.png',
                width: 100,
                href: '',
                altText: '',
                backgroundColor: '#FFFFFF',
                paddingTop: 0,
                paddingBottom: 0,
                paddingRight: 0,
                paddingLeft: 0,
                openInNewTab: false,
                textAlign: 'center',
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'fa221c95-7115-42c3-8e25-e955de6ec269',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '1. When at work, I am completely focused on my job duties ',
                options: [
                    {
                        label: 'Strongly disagree',
                        id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                        value: false,
                    },
                    {
                        label: 'Disagree',
                        id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                        value: false,
                    },
                    {
                        label: 'Neutral/ neither agree nor disagree',
                        id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                        value: false,
                    },
                    {
                        id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                        label: 'Agree',
                        value: false,
                    },
                    {
                        id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                        label: 'Strongly agree',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '2. I am determined to give my best effort at work everyday ',
                options: [
                    {
                        label: 'Strongly disagree',
                        id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                        value: false,
                    },
                    {
                        label: 'Disagree',
                        id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                        value: false,
                    },
                    {
                        label: 'Neutral/ neither agree nor disagree',
                        id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                        value: false,
                    },
                    {
                        id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                        label: 'Agree',
                        value: false,
                    },
                    {
                        id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                        label: 'Strongly agree',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '3. I am often so involved in my work that the day goes by very quickly ',
                options: [
                    {
                        label: 'Strongly disagree',
                        id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                        value: false,
                    },
                    {
                        label: 'Disagree',
                        id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                        value: false,
                    },
                    {
                        label: 'Neutral/ neither agree nor disagree',
                        id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                        value: false,
                    },
                    {
                        id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                        label: 'Agree',
                        value: false,
                    },
                    {
                        id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                        label: 'Strongly agree',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '4. I am excited about going to work ',
                options: [
                    {
                        label: 'Strongly disagree',
                        id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                        value: false,
                    },
                    {
                        label: 'Disagree',
                        id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                        value: false,
                    },
                    {
                        label: 'Neutral/ neither agree nor disagree',
                        id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                        value: false,
                    },
                    {
                        id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                        label: 'Agree',
                        value: false,
                    },
                    {
                        id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                        label: 'Strongly agree',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '5. I feel completely involved in my work ',
                options: [
                    {
                        label: 'Strongly disagree',
                        id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                        value: false,
                    },
                    {
                        label: 'Disagree',
                        id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                        value: false,
                    },
                    {
                        label: 'Neutral/ neither agree nor disagree',
                        id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                        value: false,
                    },
                    {
                        id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                        label: 'Agree',
                        value: false,
                    },
                    {
                        id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                        label: 'Strongly agree',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-radio-list',
            version: '1',
            id: '8320d454-3c77-4a83-9443-6cae6b6202ef',
            data: {
                backgroundColor: '#ffffff',
                requiredField: false,
                helperText: '',
                paddingTop: 10,
                paddingBottom: 10,
                paddingRight: 10,
                paddingLeft: 10,
                label: '6. I am inspired to meet my goals at work ',
                options: [
                    {
                        label: 'Strongly disagree',
                        id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                        value: false,
                    },
                    {
                        label: 'Disagree',
                        id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                        value: false,
                    },
                    {
                        label: 'Neutral/ neither agree nor disagree',
                        id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                        value: false,
                    },
                    {
                        id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                        label: 'Agree',
                        value: false,
                    },
                    {
                        id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                        label: 'Strongly agree',
                        value: false,
                    },
                ],
            },
        },
        {
            type: 'form-submit-button',
            version: '1',
            id: 'eb06e04c-2145-4794-af58-9fb6a65f484f',
            data: {
                backgroundColor: '#FFFFFF',
                borderColor: '#1515FF',
                borderRadius: 4,
                buttonColor: '#1515FF',
                color: '#FFFFFF',
                fontSize: 14,
                paddingBottom: 10,
                paddingLeft: 10,
                paddingRight: 10,
                paddingTop: 10,
                text: 'Submit',
                textAlign: 'center',
                width: 200,
            },
        },
    ],
    inputVariables: [],
    outputVariables: [
        {
            id: 'fa221c95-7115-42c3-8e25-e955de6ec269',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '1. When at work, I am completely focused on my job duties ',
            options: [
                {
                    label: 'Strongly disagree',
                    id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                    value: false,
                },
                {
                    label: 'Disagree',
                    id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                    value: false,
                },
                {
                    label: 'Neutral/ neither agree nor disagree',
                    id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                    value: false,
                },
                {
                    id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                    label: 'Agree',
                    value: false,
                },
                {
                    id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                    label: 'Strongly agree',
                    value: false,
                },
            ],
        },
        {
            id: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '2. I am determined to give my best effort at work everyday ',
            options: [
                {
                    label: 'Strongly disagree',
                    id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                    value: false,
                },
                {
                    label: 'Disagree',
                    id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                    value: false,
                },
                {
                    label: 'Neutral/ neither agree nor disagree',
                    id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                    value: false,
                },
                {
                    id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                    label: 'Agree',
                    value: false,
                },
                {
                    id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                    label: 'Strongly agree',
                    value: false,
                },
            ],
        },
        {
            id: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '3. I am often so involved in my work that the day goes by very quickly ',
            options: [
                {
                    label: 'Strongly disagree',
                    id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                    value: false,
                },
                {
                    label: 'Disagree',
                    id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                    value: false,
                },
                {
                    label: 'Neutral/ neither agree nor disagree',
                    id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                    value: false,
                },
                {
                    id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                    label: 'Agree',
                    value: false,
                },
                {
                    id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                    label: 'Strongly agree',
                    value: false,
                },
            ],
        },
        {
            id: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '4. I am excited about going to work ',
            options: [
                {
                    label: 'Strongly disagree',
                    id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                    value: false,
                },
                {
                    label: 'Disagree',
                    id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                    value: false,
                },
                {
                    label: 'Neutral/ neither agree nor disagree',
                    id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                    value: false,
                },
                {
                    id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                    label: 'Agree',
                    value: false,
                },
                {
                    id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                    label: 'Strongly agree',
                    value: false,
                },
            ],
        },
        {
            id: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '5. I feel completely involved in my work ',
            options: [
                {
                    label: 'Strongly disagree',
                    id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                    value: false,
                },
                {
                    label: 'Disagree',
                    id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                    value: false,
                },
                {
                    label: 'Neutral/ neither agree nor disagree',
                    id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                    value: false,
                },
                {
                    id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                    label: 'Agree',
                    value: false,
                },
                {
                    id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                    label: 'Strongly agree',
                    value: false,
                },
            ],
        },
        {
            id: '8320d454-3c77-4a83-9443-6cae6b6202ef',
            valueType: 'string',
            inputType: 'form-radio-list',
            label: '6. I am inspired to meet my goals at work ',
            options: [
                {
                    label: 'Strongly disagree',
                    id: '026f7795-6035-4019-9149-ce5e0b6678ce',
                    value: false,
                },
                {
                    label: 'Disagree',
                    id: 'cc399b03-2b2d-4a21-9524-825d1b97da51',
                    value: false,
                },
                {
                    label: 'Neutral/ neither agree nor disagree',
                    id: '729256d7-d412-4a13-b5ae-1d1239aae6d1',
                    value: false,
                },
                {
                    id: 'd44ef0bc-1eb0-45bb-8c4d-3a96ea2aa331',
                    label: 'Agree',
                    value: false,
                },
                {
                    id: '5a192261-f39a-4d6e-bc70-e782100dd94e',
                    label: 'Strongly agree',
                    value: false,
                },
            ],
        },
    ],
    workspaceId: 'FAA4358B519D0E89',
};
const prebuiltEmployeeMotivation = (workspaceId, request) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        {
            id: 0,
            variables: {
                input: [],
                output: [
                    {
                        variableName: '1. When at work, I am completely focused on my job duties ',
                        variableId: 'fa221c95-7115-42c3-8e25-e955de6ec269',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Strongly disagree","checked":"false"},{"id":2,"text":"Disagree","checked":"false"},{"id":3,"text":"Neutral/ neither agree nor disagree","checked":"false"},{"id":"ab376685-1bc5-4d84-ab50-0a7bbeb5e4bb","text":"Agree","checked":"false"},{"id":"083d977f-98d2-40ef-a438-78180df69ddc","text":"Strongly agree","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '2. I am determined to give my best effort at work everyday ',
                        variableId: '21cc0794-caac-497a-a978-9c2f5e2cca7a',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Strongly disagree","checked":"false"},{"id":2,"text":"Disagree","checked":"false"},{"id":3,"text":"Neutral/ neither agree nor disagree","checked":"false"},{"id":"39356ce5-b0b3-46e5-b04b-18474a692a4e","text":"Agree","checked":"false"},{"id":"90f2068d-3532-48bb-9e94-7386428c9bfe","text":"Strongly agree","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '3. I am often so involved in my work that the day goes by very quickly ',
                        variableId: '060784a6-eb65-4190-b0e2-ddbc1c3ed3e5',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Strongly disagree","checked":"false"},{"id":2,"text":"Disagree","checked":"false"},{"id":3,"text":"Neutral/ neither agree nor disagree","checked":"false"},{"id":"fcf60a93-e658-4714-b852-39be5fc58afa","text":"Agree","checked":"false"},{"id":"f7539d74-ac6d-4c80-85c4-500e6e97efd5","text":"Strongly agree","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '4. I am excited about going to work ',
                        variableId: '4bb936d9-1c2e-4d33-94eb-9398fb302bc5',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Strongly disagree","checked":"false"},{"id":2,"text":"Disagree","checked":"false"},{"id":3,"text":"Neutral/ neither agree nor disagree","checked":"false"},{"id":"f6c29626-a6a8-4c8a-965d-44f07477bb8d","text":"Agree","checked":"false"},{"id":"78b0fd18-028d-4d97-af47-a1f109b2c51f","text":"Strongly agree","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '5. I feel completely involved in my work ',
                        variableId: 'deec6969-f452-4835-ad3d-3b1870c2e40a',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Strongly disagree","checked":"false"},{"id":2,"text":"Disagree","checked":"false"},{"id":3,"text":"Neutral/ neither agree nor disagree","checked":"false"},{"id":"c7de88b9-caf7-4b57-92e7-c2c65824d076","text":"Agree","checked":"false"},{"id":"32d9b028-224d-4765-bd93-06e83079ee84","text":"Strongly agree","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                    {
                        variableName: '6. I am inspired to meet my goals at work ',
                        variableId: '8320d454-3c77-4a83-9443-6cae6b6202ef',
                        variableType: 'string',
                        options: '[{"id":1,"text":"Strongly disagree","checked":"false"},{"id":2,"text":"Disagree","checked":"false"},{"id":3,"text":"Neutral/ neither agree nor disagree","checked":"false"},{"id":"2c09992d-7eaf-4a3c-ac9a-aca8ad37952d","text":"Agree","checked":"false"},{"id":"7a8f62ef-2358-4dee-aee9-5c9fe3b24d0f","text":"Strongly agree","checked":"false"}]',
                        type: 'FormRadioList',
                    },
                ],
            },
            type: 'start',
            next: null,
            isDirty: true,
            version: '1.0.2',
            data: {
                stepName: 'Trigger',
                triggers: [
                    {
                        id: 0,
                        type: 'form',
                        data: {
                            form: yield (0, templateUtils_1.getContentData)({
                                request: () => __awaiter(void 0, void 0, void 0, function* () { return request(Object.assign(Object.assign({}, triggerFormContent), { workspaceId })); }),
                            }),
                        },
                    },
                ],
            },
        },
    ];
});
exports.prebuiltEmployeeMotivation = prebuiltEmployeeMotivation;
//# sourceMappingURL=employeeMotivation.js.map